<nmo-simple-header *ngIf="!videoOnly"></nmo-simple-header>

<div class="ad-info" *ngIf="!videoOnly">Entgeltliche Einschaltung</div>
<!--<app-jwplayer *ngIf="mediaId" [mediaId]="mediaId"></app-jwplayer>-->
<app-radiant-player *ngIf="mediaId" [mediaId]="mediaId"></app-radiant-player>

<nmo-simple-footer *ngIf="!videoOnly"></nmo-simple-footer>
